import Config from 'common-src/config';

export const generateAthenaUrl = (integration) => {
  const mainUrl = `${Config.ATHENA_URL}/${integration.practiceId}/7/client/clientsummary.esp?ID=${integration.athenaPatientId}`;
  const url = `${Config.ATHENA_URL}/${integration.practiceId}/7/globalframeset.esp?MAIN=${encodeURIComponent(mainUrl)}`;
  return url;
};
